import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { createChewyApiClient } from '@chewy/loyalty-graphql-client';

import { AvailableMembershipPlansDocument, AvailableMembershipPlansQuery } from './__generated__';
import {
  createServerGraphQLClient,
  ServerGraphQLHeaderValue,
} from './create-server-graphql-client';

const CLIENT_GRAPHQL_URI = '/api/api-router/graphql';
const COMPONENT_ID = 'loyalty-ui';

let browserClient: ApolloClient<NormalizedCacheObject> | undefined;

export interface FetchAvailableMembershipPlansServerOptions {
  headers?: Record<string, ServerGraphQLHeaderValue>;
}

const queryAvailableMembershipPlans = async (client: ApolloClient<NormalizedCacheObject>) => {
  const result = await client.query<AvailableMembershipPlansQuery>({
    query: AvailableMembershipPlansDocument,
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
  });

  if (!result.data) {
    throw new Error('AvailableMembershipPlans returned no GraphQL data');
  }

  return result.data.loyaltyAvailableMembershipPlans ?? null;
};

export const fetchAvailableMembershipPlansClient = () => {
  browserClient ??= createChewyApiClient({
    uri: CLIENT_GRAPHQL_URI,
    headers: { 'x-chewy-component-id': COMPONENT_ID },
  });

  return queryAvailableMembershipPlans(browserClient);
};

export const fetchAvailableMembershipPlansServer = async ({
  headers,
}: FetchAvailableMembershipPlansServerOptions = {}) => {
  const client = createServerGraphQLClient({
    headers,
    missingUrlWarning:
      '[available-membership-plans] CHEWY_API_GRAPHQL_URL is not set; membership plan trajectories disabled.',
  });

  return client ? await queryAvailableMembershipPlans(client) : undefined;
};
